import { render, staticRenderFns } from "./SoftwareDetails.vue?vue&type=template&id=c4117f7c&scoped=true&"
import script from "./SoftwareDetails.vue?vue&type=script&lang=js&"
export * from "./SoftwareDetails.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareDetails.vue?vue&type=style&index=0&id=c4117f7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4117f7c",
  null
  
)

export default component.exports